<template lang="html">
    <div class="client-settings__card">
        <h2 class="header-2">
            Informații de facturare
        </h2>
        <FormBillingInfo />
    </div>
</template>

<script>

import UiButton from "@/components/ui/Button"
import FormUpdatePassword from '@/components/forms/Settings/Password'
import FormBillingInfo from '@/components/forms/Settings/BillingInfo'

import { mapActions } from 'vuex'

export default {
    components: {
        UiButton,
        FormUpdatePassword,
        FormBillingInfo
    },
    data() {
        return {
            activeNextStep: false
        };
    },
    methods: {
        ...mapActions({
            updatePassword: 'settings/updatePassword'
        }),
        sendUpdatePassword() {
            if(this.activeNextStep) {
                this.updatePassword();
                this.$store.state.settings.currentStep = 0;
            }
        }
    }
}
</script>

<style lang="css" scoped>

</style>
